// extracted by mini-css-extract-plugin
export default {"container":"SportsmanPage_container__AxHch","linkContainer":"SportsmanPage_linkContainer__-XFr1","row":"SportsmanPage_row__anQni","link":"SportsmanPage_link__TSS-G"};